module.exports = "/images/side-files.svg?0a86dd644fd50dea3a80023f62636645";